import React from 'react';
import { Alert, type AlertProps } from 'antd';
import { t } from 'i18next';
import clsx from 'clsx';

import styles from './Toast.module.css';

export const Toast = ({ className, ...alertProps }: AlertProps) => {
  return (
    <Alert
      data-testid="toaster"
      showIcon
      closable={{ closeIcon: true, 'aria-label': t('toast.close') }}
      {...alertProps}
      className={clsx(styles.toast, className)}
    />
  );
};
